// @see https://www.storyblok.com/docs/image-service/

export function imageBuilder(url: string): ImageBuilder {
	return new ImageBuilder(url);
}

export type ImageFormat = 'jpeg' | 'png' | 'webp' | 'avif';

class ImageBuilder {
	private imageUrl: string;
	private _width: number = 0;
	private _height: number = 0;
	private _format: ImageFormat | undefined;

	constructor(imageUrl: string) {
		this.imageUrl = imageUrl;
	}

	width = (width: number): ImageBuilder => {
		this._width = width;
		return this;
	};

	height = (height: number): ImageBuilder => {
		this._height = height;
		return this;
	};

	size = (width: number, height: number): ImageBuilder => {
		this._width = width;
		this._height = height;
		return this;
	};

	format = (format: typeof this._format): ImageBuilder => {
		this._format = format;
		return this;
	};

	url = (): string => {
		if (this.imageUrl.endsWith('.svg')) {
			return this.imageUrl;
		}

		const baseUrl = `${this.imageUrl}/m/${this._width}x${this._height}`;

		if (this._format) {
			return `${baseUrl}/filters:format(${this._format})`;
		}

		return baseUrl;
	};
}
